var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGoNext = function SvgIconGoNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFFDFC",
    d: "m17.414 10.586-4.293-4.293-1.414 1.414L15 11H5v2h10l-3.293 3.293 1.414 1.414 4.293-4.293a2 2 0 0 0 0-2.828"
  })));
};
export { SvgIconGoNext as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjQxNCAxMC41ODZMMTMuMTIxIDYuMjkyOTdMMTEuNzA3IDcuNzA2OTdMMTUgMTFINVYxM0gxNUwxMS43MDcgMTYuMjkzTDEzLjEyMSAxNy43MDdMMTcuNDE0IDEzLjQxNEMxNy43ODg5IDEzLjAzODkgMTcuOTk5NiAxMi41MzAzIDE3Ljk5OTYgMTJDMTcuOTk5NiAxMS40Njk2IDE3Ljc4ODkgMTAuOTYxIDE3LjQxNCAxMC41ODZaIiBmaWxsPSIjRUZGREZDIi8+Cjwvc3ZnPgo=";